import { Modal } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import { AddPaymentMethod } from '../../../../containers'
import { StripeElements } from '../../../../layout/StripeElements'

interface StripeDetailsProps {
  /**
   * Optional invoice ID (if routing back to pay invoice modal after adding card).
   */
  invoiceId?: string
}

export const StripeDetails: React.FC<StripeDetailsProps> = ({ invoiceId }) => {
  const { t } = useTranslation('modals/settings/billing')

  return (
    <>
      <Modal.Header title={t`addCreditCard.title`}></Modal.Header>
      <Modal.Body>
        <div className="flex size-full flex-col px-8 pb-4">
          <StripeElements>
            <AddPaymentMethod invoiceId={invoiceId} />
          </StripeElements>
        </div>
      </Modal.Body>
    </>
  )
}
